import { Pipe, inject } from '@angular/core';
import { CurrencyService } from '@fantaz/shared/utils';

@Pipe({
  name: 'fzCurrency',
  pure: true,
  standalone: true,
})
export class CurrencyPipe {
  #currencyService = inject(CurrencyService);

  transform(value: number): string {
    const dollar = this.#currencyService.convertDollar(value);
    return `${dollar} USD`;
  }
}
